export const INBOX_COLUMNS = [
    { "id": "order_number", "type": "text", "label": "Order #", "sortable": true },
    { "id": "order_state", "type": "text", "label": "State", "sortable": true },
    { "id": "claim_date", "type": "text", "label": "Claim Date", "sortable": true },
    { "id": "creation_date", "type": "text", "label": "Create Date", "sortable": true },
    { "id": "manufacturer", "type": "text", "label": "Manufacturer", "sortable": true },
    { "id": "model", "type": "text", "label": "Model", "sortable": true },
    { "id": "plate_number", "type": "text", "label": "Plate Number", "sortable": true },
    { "id": "vin", "type": "text", "label": "VIN", "sortable": true },
    { "id": "participant_vo_name1", "type": "text", "label": "VO Name 1", "sortable": true },
    { "id": "participant_vo_name2", "type": "text", "label": "VO Name 2", "sortable": true },
    { "id": "participant_vo_name3", "type": "text", "label": "VO Name 3", "sortable": true },
    { "id": "participant_cu_name1", "type": "text", "label": "CU Name 1", "sortable": true },
    { "id": "participant_cu_name2", "type": "text", "label": "CU Name 1", "sortable": true },
    { "id": "participant_cu_name3", "type": "text", "label": "CU Name 1", "sortable": true },
];